import React from 'react';
import { Box, Modal, Paper, Grid, Typography, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {ExportToExcelTicket} from "../export_report/Export_ticket";
import DownloadIcon from "@mui/icons-material/Download";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%', 
  maxHeight: '80vh', 
  overflowY: 'auto', 
  p: 2, 
};

const columnStyle = {
  margin: '0 1rem', 
};

const itemStyle = {
  marginBottom: '1rem', 
};

const TicketModal = ({ openModal, handlerClose, ticketSel }) => {
  const data = ticketSel.row ? ticketSel.row :{}
  
  return (
    <Modal
      open={openModal}
      onClose={handlerClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box display="flex" justifyContent="center" astronggnItems="center" sx={modalStyle}>
        <Paper sx={{ p: 2 }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%' }}>
            <IconButton aria-label="close-ticket-modal-btn" size="medium" onClick={handlerClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <Typography variant="h6">Detalle del ticket</Typography>
          <Grid container spacing={2}>
            <Grid item xs={5} style={columnStyle}>
              <div style={itemStyle}>
                <strong>Id: </strong>{data.ticketId}
              </div>
              <div style={itemStyle}>
                <strong>Sitio: </strong>{data.sitioId}
              </div>
              <div style={itemStyle}>
                <strong>Reporte SOC: </strong>{data.numreportesoc}
              </div>
              <div style={itemStyle}>
                <strong>Reportes Bestel:</strong> {data.numreportebestel}
              </div>
              <div style={itemStyle}>
                <strong>Reporte Cstrongente: </strong>{data.numreportecstrongente}
              </div>
              <div style={itemStyle}>
                <strong>Fecha Inicio: </strong>{data.fcInicioTicket}
              </div>
              <div style={itemStyle}>
                <strong>Fecha Fin: </strong>{data.fcFinticket}
              </div>
              <div style={itemStyle}>
                <strong>Estatus:</strong> {data.dsticketstatus}
              </div>
              <div style={itemStyle}>
                <strong>Actividad: </strong>{data.actividad}
              </div>
              <div style={itemStyle}>
                <strong>Responsable: </strong>{data.responsable}
              </div>
              <div style={itemStyle}>
                <strong>Ingeniero Asignado: </strong>{data.ingasignado}
              </div>
              <div style={itemStyle}>
                <strong>Descripción: </strong>{data.descripcion}
              </div>
              <div style={itemStyle}>
                <strong>Severidad: </strong>{data.severidad}
              </div>
              <div style={itemStyle}>
                <strong>Tuvo Afectación: </strong>{data.boafectacion}
              </div>
              <div style={itemStyle}>
                <strong>Afectación Atribuible a Bestel: </strong>{data.boatribuible}
              </div>
            </Grid>
            <Grid item xs={5} style={columnStyle}>
              <div style={itemStyle}>
                <strong>Caso Id: </strong>{data.casoid}
              </div>
              <div style={itemStyle}>
                <strong>Usuario que Reporta:</strong> {data.usuarioreporta}
              </div>
              <div style={itemStyle}>
                <strong>Usuario a Cargo:</strong> {data.usuariocargo}
              </div>
              <div style={itemStyle}>
                <strong>Enlace:</strong> {data.refenlace}
              </div>
              <div style={itemStyle}>
                <strong>Tipo Falla:</strong> {data.dstipofalla}
              </div>
              <div style={itemStyle}>
                <strong>Tipo Requerimiento:</strong> {data.dsrequerimiento}
              </div>
              <div style={itemStyle}>
                <strong>Criticidad:</strong> {data.dscriticidad}
              </div>
              <div style={itemStyle}>
                <strong>Tipo Ticket: </strong>{data.dstickettipo}
              </div>
              <div style={itemStyle}>
                <strong>Detalle Ticket: </strong>{data.detalle}
              </div>
            </Grid>
          </Grid>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%' }}>
            <IconButton  onClick={() => ExportToExcelTicket(data)}>
              <DownloadIcon/>
            </IconButton>
            Exportar a Excel
          </div>
        </Paper>
      </Box>
    </Modal>
  );
};

export default TicketModal;
